import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.universal.orgStructure.withoutDivisions',
    'package:data.higherEd.space',
    'resource:data.dimensions.organizationSpace.entities.entry.attributes.organization',
    'resource:data.dimensions.organizationSpace.entities.entry.attributes.space',
    'resource:data.dimensions.organizationSpace.entities.entry.attributes.isOccupier',
    'resource:data.dimensions.organizationSpace.entities.entry',
    'resource:data.dimensions.organizationSpace',
    'resource:data.dimensions.personnelSpace.entities.entry.attributes.personnel',
    'resource:data.dimensions.personnelSpace.entities.entry.attributes.space',
    'resource:data.dimensions.personnelSpace.entities.entry',
    'resource:data.dimensions.personnelSpace',
  ],
  description: 'TODO',
  name: 'Data - Org Structure Space',
} as const satisfies core.quiver.Package
